import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './DisplayApiLogs.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://multi-counter.bancheng.tech/api';

function DisplayApiLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [autoRefresh, setAutoRefresh] = useState(true);

  const fetchLogs = async () => {
    try {
      const response = await axios.get(`${API_URL}/displays/logs`);
      setLogs(response.data.logs || []);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching logs:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();

    if (autoRefresh) {
      const interval = setInterval(fetchLogs, 3000); // 每3秒刷新
      return () => clearInterval(interval);
    }
  }, [autoRefresh]);

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('zh-TW', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const getStatusColor = (status) => {
    if (status >= 200 && status < 300) return 'success';
    if (status >= 400 && status < 500) return 'error';
    if (status >= 500) return 'server-error';
    return '';
  };

  if (loading) {
    return <div className="logs-container"><div className="loading">載入中...</div></div>;
  }

  return (
    <div className="logs-container">
      <div className="logs-header">
        <h1>顯示器 API 日誌</h1>
        <div className="controls">
          <label>
            <input
              type="checkbox"
              checked={autoRefresh}
              onChange={(e) => setAutoRefresh(e.target.checked)}
            />
            自動刷新 (3秒)
          </label>
          <button onClick={fetchLogs} className="btn btn-primary">
            手動刷新
          </button>
        </div>
      </div>

      <div className="logs-stats">
        <div className="stat">總共 {logs.length} 筆日誌</div>
      </div>

      <div className="logs-list">
        {logs.length === 0 ? (
          <div className="no-logs">目前沒有日誌記錄</div>
        ) : (
          logs.map((log, index) => (
            <div key={index} className={`log-entry ${getStatusColor(log.status)}`}>
              <div className="log-header">
                <span className="log-time">{formatTime(log.timestamp)}</span>
                <span className={`log-status status-${log.status}`}>{log.status}</span>
                <span className="log-method">{log.method}</span>
                <span className="log-path">{log.path}</span>
              </div>
              
              <div className="log-section">
                <h4>📤 Request Body:</h4>
                <pre>{JSON.stringify(log.body, null, 2)}</pre>
              </div>

              <div className="log-section">
                <h4>📥 Response:</h4>
                <pre>{JSON.stringify(log.response, null, 2)}</pre>
              </div>

              {log.errorStack && (
                <div className="log-section error-stack">
                  <h4>⚠️ Error Stack:</h4>
                  <pre>{log.errorStack}</pre>
                </div>
              )}

              <div className="log-meta">
                <span>IP: {log.ip}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default DisplayApiLogs;
